import {
  faAngleDown,
  faAnglesUpDown,
  faAngleUp,
  faArrowDown,
  faArrowDownRight,
  faArrowDownWideShort,
  faArrowLeft,
  faArrowRightFromBracket,
  faArrowRotateLeft,
  faArrowRotateRight,
  faArrowsRepeat,
  faArrowsRetweet,
  faArrowsUpDownLeftRight,
  faArrowUp,
  faArrowUpRight,
  faBan,
  faBars,
  faBell,
  faBellExclamation,
  faBellRing,
  faBinRecycle,
  faBoltLightning,
  faBridgeWater,
  faBuilding,
  faCalendarRange,
  faCartFlatbedBoxes,
  faChartColumn,
  faChartMixed,
  faChartMixedUpCircleDollar,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleBolt,
  faCircleCheck,
  faCircleInfo,
  faCircleMinus,
  faCirclePause,
  faCirclePlay,
  faCity,
  faClockRotateLeft,
  faClose,
  faCloud,
  faCloudArrowDown,
  faCloudArrowUp,
  faCloudRain,
  faCloudSunRain,
  faCodeBranch,
  faCompressAlt,
  faCopy,
  faDatabase,
  faDisplayChartUp,
  faDisplayChartUpCircleDollar,
  faDownload,
  faDroplet,
  faEarthAfrica,
  faEllipsis,
  faEnvelopeOpenDollar,
  faExpandAlt,
  faEye,
  faEyeSlash,
  faFile,
  faFileArrowDown,
  faFileBracketsCurly,
  faFileCheck,
  faFileCode,
  faFileCsv,
  faFileExcel,
  faFileExport,
  faFileImage,
  faFileImport,
  faFileInvoiceDollar,
  faFileLines,
  faFilePdf,
  faFilePowerpoint,
  faFileUser,
  faFileWord,
  faFileXml,
  faFileZip,
  faFireBurner,
  faFireFlameCurved,
  faFlag,
  faFolderOpen,
  faGauge,
  faGaugeHigh,
  faGaugeLow,
  faGaugeSimpleMax,
  faGear,
  faGlobe,
  faHandshake,
  faHandWave,
  faHourglassClock,
  faHouse,
  faHouseBlank,
  faHouseChimneyUser,
  faImagePolaroid,
  faInbox,
  faArrowRightArrowLeft,
  faIndustryWindows,
  faLayerGroup,
  faLeaf,
  faLinkHorizontal,
  faLinkHorizontalSlash,
  faLocationCrosshairs,
  faLocationDot,
  faLock,
  faLockOpen,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faMapLocationDot,
  faMeter,
  faMobileButton,
  faNetworkWired,
  faNewspaper,
  faOilCanDrip,
  faPaperclip,
  faPause,
  faPen,
  faPenToSquare,
  faPieChart,
  faPipeCircleCheck,
  faPlug,
  faPlus,
  faQuestionCircle,
  faRectangle,
  faRouter,
  faScrubber,
  faSearch,
  faShareNodes,
  faShieldCheck,
  faShieldSlash,
  faSignal,
  faSignalBarsSlash,
  faSnowflake,
  faSolarPanel,
  faSparkles,
  faSpinnerThird,
  faStar,
  faSuitcase,
  faSync,
  faTable,
  faTableLayout,
  faTemperatureHigh,
  faTemperatureSnow,
  faTemperatureThreeQuarters,
  faThumbsUp,
  faThumbtack,
  faTimer,
  faToolbox,
  faTrashCan,
  faTree,
  faTrees,
  faTriangleExclamation,
  faUpload,
  faUser,
  faUserGear,
  faUsers,
  faUserTag,
  faUtilityPole,
  faUtilityPoleDouble,
  faWater,
  faWaterArrowUp,
  faWifi,
  faWindTurbine,
  faWineBottle,
  faWrench,
  faXmark,
  faXmarkCircle,
} from '@fortawesome/pro-light-svg-icons';
import {
  faChevronLeft as faChevronLeftSolid,
  faChevronRight as faChevronRightSolid,
  faCircle,
  faCircleCheck as faCircleCheckSolid,
  faCircleExclamation,
  faCircleInfo as faCircleInfoSolid,
  faCircleMinus as faCircleMinusSolid,
  faCirclePlus as faCirclePlusSolid,
  faCircleXmark as faCircleXmarkSolid,
  faDiamondExclamation,
  faDoNotEnter,
  faDot,
  faEllipsisStrokeVertical,
  faFireFlameCurved as faFireFlameCurvedSolid,
  faFloppyDisk,
  faGridHorizontal,
  faGripDots,
  faInfo,
  faInfoSquare as faInfoSquareSolid,
  faMap,
  faMessageQuestion,
  faPlusLarge,
  faThumbTack as faThumbtackSolid,
  faTriangleExclamation as faTriangleExclamationSolid,
} from '@fortawesome/pro-solid-svg-icons';

export const FONT_AWESOME_ICONS = {
  air: faWineBottle,
  analysis: faChartMixed,
  angelsUpDown: faAnglesUpDown,
  angleDown: faAngleDown,
  angleUp: faAngleUp,
  arrowDown: faArrowDown,
  arrowDownRight: faArrowDownRight,
  arrowLeft: faArrowLeft,
  arrowUp: faArrowUp,
  arrowUpRight: faArrowUpRight,
  auditLog: faClockRotateLeft,
  ban: faBan,
  bars: faBars,
  bellExclamation: faBellExclamation,
  bellRing: faBellRing,
  binRecycle: faBinRecycle,
  bridgeWater: faBridgeWater,
  building: faBuilding,
  calendarRange: faCalendarRange,
  carbonFootprint: faEarthAfrica,
  cartFlatbedBoxes: faCartFlatbedBoxes,
  chartUpCircleDollar: faDisplayChartUpCircleDollar,
  check: faCheck,
  chevronDown: faChevronDown,
  chevronLeft: faChevronLeft,
  chevronLeftSolid: faChevronLeftSolid,
  chevronRight: faChevronRight,
  chevronRightSolid: faChevronRightSolid,
  chevronUp: faChevronUp,
  circleCheck: faCircleCheck,
  circleCheckSolid: faCircleCheckSolid,
  circleExclamation: faCircleExclamation,
  circleMinus: faCircleMinus,
  circleMinusSolid: faCircleMinusSolid,
  circlePause: faCirclePause,
  circlePlay: faCirclePlay,
  circlePlusSolid: faCirclePlusSolid,
  circleSolid: faCircle,
  city: faCity,
  close: faClose,
  cloudDownload: faCloudArrowDown,
  cloudRain: faCloudRain,
  cloudUpload: faCloudArrowUp,
  codeBranch: faCodeBranch,
  columnChart: faChartColumn,
  compressAlt: faCompressAlt,
  copy: faCopy,
  cost: faChartMixedUpCircleDollar,
  dashboard: faDisplayChartUp,
  database: faDatabase,
  delete: faTrashCan,
  diamondExclamationSolid: faDiamondExclamation,
  doNotEnter: faDoNotEnter,
  dot: faDot,
  download: faDownload,
  edit: faPen,
  editSquare: faPenToSquare,
  electricity: faBoltLightning,
  electricityHighVoltage: faUtilityPole,
  electricityLowVoltage: faPlug,
  electricityVeryHighVoltage: faUtilityPoleDouble,
  ellipses: faEllipsis,
  ELTO: faOilCanDrip,
  envelopeDollar: faEnvelopeOpenDollar,
  excelDocument: faFileExcel,
  expandAlt: faExpandAlt,
  exports: faFileArrowDown,
  eye: faEye,
  eyeSlash: faEyeSlash,
  favourites: faStar,
  file: faFile,
  fileCheck: faFileCheck,
  fileCsv: faFileCsv,
  fileExcel: faFileExcel,
  fileExport: faFileExport,
  fileImport: faFileImport,
  fileImage: faFileImage,
  fileJson: faFileBracketsCurly,
  fileXml: faFileXml,
  fireBurner: faFireBurner,
  flag: faFlag,
  floppyDisk: faFloppyDisk,
  folderOpen: faFolderOpen,
  gas: faFireFlameCurved,
  gasLargeScale: faGaugeHigh,
  gasSmallScale: faGaugeLow,
  gasMediumScale: faGauge,
  gasSolid: faFireFlameCurvedSolid,
  gauge: faGauge,
  gaugeHigh: faGaugeHigh,
  generator: faCircleBolt,
  globe: faGlobe,
  gridHorizontal: faGridHorizontal,
  gripDots: faGripDots,
  handshake: faHandshake,
  handWave: faHandWave,
  heat: faTemperatureSnow,
  home: faHouse,
  homeBlank: faHouseBlank,
  houseUser: faHouseChimneyUser,
  HTMLFile: faFileCode,
  image: faImagePolaroid,
  inbox: faInbox,
  industryWindows: faIndustryWindows,
  info: faInfo,
  infoCircle: faCircleInfo,
  infoSolid: faCircleInfoSolid,
  infoSquare: faInfoSquareSolid,
  invoice: faFileInvoiceDollar,
  leaf: faLeaf,
  level: faWaterArrowUp,
  linkHorizontal: faLinkHorizontal,
  locationDot: faLocationDot,
  lock: faLock,
  login: faLockOpen,
  logout: faArrowRightFromBracket,
  map: faMap,
  mapLayers: faLayerGroup,
  mapLocationDot: faMapLocationDot,
  messageQuestionSolid: faMessageQuestion,
  meteo: faCloudSunRain,
  meter: faMeter,
  mobileButton: faMobileButton,
  move: faArrowsUpDownLeftRight,
  networkWired: faNetworkWired,
  newspaper: faNewspaper,
  notification: faBell,
  notificationTime: faGaugeSimpleMax,
  paperclip: faPaperclip,
  pause: faCirclePause,
  pauseOnly: faPause,
  pdfDocument: faFilePdf,
  pellets: faTree,
  pieChart: faPieChart,
  pipeCircleCheck: faPipeCircleCheck,
  plus: faPlus,
  plusLarge: faPlusLarge,
  powerPointDocument: faFilePowerpoint,
  questionCircle: faQuestionCircle,
  rectangle: faRectangle,
  refresh: faArrowRotateRight,
  reload: faArrowRotateLeft,
  repeat: faArrowsRepeat,
  replace: faArrowsRetweet,
  report: faUserTag,
  reset: faArrowsRepeat,
  router: faRouter,
  scope: faLocationCrosshairs,
  scrubber: faScrubber,
  search: faSearch,
  settings: faGear,
  share: faShareNodes,
  shieldCheck: faShieldCheck,
  shieldSlash: faShieldSlash,
  signal: faSignal,
  signalBarSlash: faSignalBarsSlash,
  snowflake: faSnowflake,
  solarPanel: faSolarPanel,
  sortLines: faArrowDownWideShort,
  sparkles: faSparkles,
  spinner: faSpinnerThird,
  steam: faCloud,
  sync: faSync,
  suitcase: faSuitcase,
  table: faTable,
  tableLayout: faTableLayout,
  temperature: faTemperatureThreeQuarters,
  temperatureHigh: faTemperatureHigh,
  textDocument: faFileLines,
  threeDotMenu: faEllipsisStrokeVertical,
  thumbsUp: faThumbsUp,
  thumbtack: faThumbtack,
  thumbtackSolid: faThumbtackSolid,
  timer: faTimer,
  transfer: faArrowRightArrowLeft,
  toolbox: faToolbox,
  trees: faTrees,
  triangleExclamation: faTriangleExclamation,
  triangleExclamationSolid: faTriangleExclamationSolid,
  unlinkHorizontal: faLinkHorizontalSlash,
  upload: faUpload,
  user: faUser,
  userFile: faFileUser,
  userSettings: faUserGear,
  users: faUsers,
  waiting: faHourglassClock,
  water: faDroplet,
  waterWaves: faWater,
  wifi: faWifi,
  windTurbine: faWindTurbine,
  wordDocument: faFileWord,
  wrench: faWrench,
  xMark: faXmark,
  xmarkCircle: faXmarkCircle,
  xmarkCircleSolid: faCircleXmarkSolid,
  zipFile: faFileZip,
  zoomIn: faMagnifyingGlassPlus,
  zoomOut: faMagnifyingGlassMinus,
} as const;
